import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useClient from 'api/client';
import getCluster from 'api/RedshiftCluster/getCluster';
import { useAlert } from 'components/message/AlertContext';
import { ItemsDetails } from 'components/details/EditorDetails';
import { FormatDate } from 'components/dates/FormatDate';

export default function useCluster() {
    const client = useClient();
    const params = useParams();
    const { openAlert } = useAlert();
    const [cluster, setCluster] = useState({
        label: '',
        stack: { status: '' },
    });
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState<ItemsDetails>({
        created: '',
        label: '',
        description: '',
        data: [],
    });
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                if (params.uri) {
                    const response = await client?.query(
                        getCluster(params.uri),
                    );

                    if (response && !response.errors) {
                        setCluster(response.data.getRedshiftCluster);
                        setItems({
                            created: FormatDate(
                                response.data.getRedshiftCluster.created,
                            ),
                            label: response.data.getRedshiftCluster.label,
                            description:
                                response.data.getRedshiftCluster.description,
                            data: [
                                {
                                    label: 'Organization',
                                    value: response.data.getRedshiftCluster
                                        .organization.label,
                                    uri: `/organization/${response.data.getRedshiftCluster.organization.organizationUri}`,
                                },
                                {
                                    label: 'Created by',
                                    value: response.data.getRedshiftCluster
                                        .owner,
                                },
                                {
                                    label: 'Admin group',
                                    value: response.data.getRedshiftCluster
                                        .SamlGroupName,
                                },
                                {
                                    label: 'This user is',
                                    value: response.data.getRedshiftCluster
                                        .userRoleForCluster,
                                },
                                {
                                    label: 'Environment',
                                    value: `${response.data.getRedshiftCluster.environment.label}`,
                                    uri: `/environment/${response.data.getRedshiftCluster.environment.environmentUri}`,
                                },
                                {
                                    label: 'Region',
                                    value: response.data.getRedshiftCluster
                                        .stack.region,
                                },
                                {
                                    label: 'VPC',
                                    value: response.data.getRedshiftCluster.vpc,
                                },
                                {
                                    label: 'Authorized Resouces',
                                    value: response.data.getRedshiftCluster
                                        .authorized_resources,
                                },
                            ],
                        });
                    } else {
                        setError(true);
                        openAlert({
                            message: 'Error fecthing cluster',
                            severity: 'alert',
                        });
                    }
                }
            } finally {
                setLoading(false);
            }
        };
        if (client) {
            fetchData();
        }
    }, [client, params.uri]);

    return { cluster, items, error, loading };
}
